import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@src/app/app.module';
import { environment } from '@src/environments/environment';

//integración de Sentry
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://cb8cd43444d146c590781f148becc5a4@o219430.ingest.sentry.io/5644558",
});
import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {preserveWhitespaces: false})
  .catch(err => console.log(err));